import React from "react";
import { useDispatch } from "react-redux";
import { useKeycloak } from "@react-keycloak/web";
import md5 from "md5";
import ScreenLoader from "../Components/shared/ScreenLoader";
import { setupAuth } from "../api/apiClient";
import { licenseServices } from "../Components/License/services/license.bank.service";
import {
  createTokenExpiredAt,
  createRefreshTokenExpiredAt,
} from "../utils/helperFunctions";

const LicenseCheckGate = () => {
  const { keycloak } = useKeycloak();
  const dispatch = useDispatch();
  console.log(keycloak);
  if (keycloak.tokenParsed["license-key"]) {
    const licenseId = keycloak.tokenParsed["license-key"];
    const combination = `${keycloak.tokenParsed["preferred_username"]}-${keycloak.tokenParsed.bankName}`;
    let token = md5(combination);

    const tokenData = localStorage.getItem("corzapAuth");

    token = `${token}-${createRefreshTokenExpiredAt(
      keycloak.refreshTokenParsed.exp
    )}`;

    //fn (validate) validates the license with a token an expiry date and sets corzap key in localstorage
    const validate = () => {
      localStorage.setItem(
        "corzapAuth",
        JSON.stringify({
          token: token,
          expiry: keycloak.refreshTokenParsed.exp,
        })
      );

      const data = {
        token: token,
        expiredAt: createTokenExpiredAt(keycloak.refreshTokenParsed.exp),
      };

      licenseServices
        .validateLicense(licenseId, data)
        .then(() => {
          setupAuth(keycloak.tokenParsed["license-key"], token);

          dispatch({
            type: "SET_IS_LICENSE_CHECKED",
          });

          dispatch({
            type: "SET_TOKEN",
            payload: { token: token },
          });
        })
        .catch((e) => alert(e.message));
    };

    if (tokenData) {
      const json = JSON.parse(tokenData);

      //check if the current "corzapAuth" data is expired
      if (Date.now() > json.expiry * 1000) {
        //invalidate
        licenseServices
          .inValidateLicense(keycloak.tokenParsed["license-key"], {
            token: token,
          })
          .then(() => {})
          .catch((e) => alert(e.message));

        //remove old data
        localStorage.removeItem("corzapAuth");

        //validate with new data
        validate();
      } else {
        setupAuth(keycloak.tokenParsed["license-key"], token);

        dispatch({
          type: "SET_IS_LICENSE_CHECKED",
        });

        dispatch({
          type: "SET_TOKEN",
          payload: { token: token },
        });
      }
    } else {
      validate();
    }
  }

  return <ScreenLoader />;
};

export default LicenseCheckGate;
